/**
 * 话题
 */
import React, {Component} from 'react';
import url from 'c-url';
import notification from 'c-notification';

// import shareClick from '../component/shareclick/index';
import dl from '../component/download/dl';
import Title from 'c-title';
import Topic from '../component/topic/index';
import HotDynamicList from './hots';
import NewDynamicList from './news';
import lang from '../lang';

class TopicView extends Component {
	
	static defaultProps = {
            rid: '',
            dynamicId: ''
        }

    constructor(props) {
        super(props);

        this.state = {
            data: null,
            fetching: true,
            listType: 'hot'
        };

        this.rid = url.query('rid');
        this.dynamicId = url.query('dynamicId');
    }

    componentWillMount() {
        if (!this.rid || !this.dynamicId) {
            notification.simple('parameter error');
            return;
        }
        this.getData();
    } 


    componentDidMount() {
        $.channel.on('download', ()=>{
            dl();
        })
        
        // shareClick.send({
        //     targetId: url.query('dynamicId'),
        //     type: 'topic'
        // });


        $(window).on('scroll', ()=>{
            this.refs.list && this.refs.list.scroll();
        })
    }

    componentWillUnmount(){
        $(window).off('scroll');
    }


	// 获取话题详情
	getData() {
		let self = this;
        let promise = new Topic({
            topicId: parseInt(this.dynamicId, 10)
        }).promise;

        promise.done((data)=>{
            if (data.errmsg) {
                this.setState({
                    fetching: false,
                    errmsg: data.errmsg == 'noexist' ? lang.template('哎哟，页面不见了') : lang.template('哎哟，页面无法查看，请稍候再试')
                });
            } else {
                this.setState({
                    data: data,
                    topicInfo: data.topicInfo,
                    fetching: false
                });

                Title.set('#' + data.topicInfo.topicName + '#');
            }
        });

        promise.fail(()=>{
            this.setState({
                fetching: false,
                errmsg: lang.template('哎哟，页面无法查看，请稍候再试')
            });
        })
	}

	selectList(type){
        if (this.state.listType == type){
            return;
        }

        this.setState({
            listType: type
        });
    }  


	render() {
		let $content;
        let $list;

        if (this.state.fetching) {
            return (
                <div className="mini-loading">
                    <div className="loading-tip">{lang.template('正在加载')}<em>.</em><em>.</em><em>.</em></div>
                </div>
            );
        } else {

            if (this.state.errmsg) {
                $content = (
                    <div className="content-wrapper">
                        <div className="mini-notice">
                            <i></i>
                            <span className="tip">{ this.state.errmsg }</span>
                        </div>
                        <div className="btns">
                            <div className="btn" onClick={()=> $.channel.emit('download')}>{ lang.template('打开Up直播，直播全世界') }</div>
                        </div>
                    </div>
                )
            } else {
                let { topicInfo, hotDynamicList} = this.state.data;

                $content = (
                    <div className="content-wrapper">
                        <div className="topic-bg" style={{backgroundImage: `url(${topicInfo.coverUrl})`}}></div>
                    	<div className="topic-wrapper">
	                        <h2 className="title">{topicInfo.topicName}</h2>
							<p className="description">{topicInfo.summary}</p>
							<ul className="box">
                                <li className="partake"> 
                                    <i></i>
                                    <em>{ longToString(topicInfo.partakeNum) || 0}</em>
                                </li>
                                <li className="videonum">
                                    <i></i>
                                    <em>{ longToString(topicInfo.allVideoNum) || 0 }</em>
                                </li>
								<li className="looknum">
                                    <i></i>
                                    <em>{ longToString(topicInfo.onLookNum) || 0}</em>
                                </li>
							</ul>
						</div>
                    </div>
                )

                if (hotDynamicList.length > 0) {
                    $list =  <HotDynamicList list={hotDynamicList}/>;
                } else {
                    $list = (
                        <div className="mini-empty">
                            <span className="tip">{ lang.template('记录你的精彩瞬间，让世界一起见证')}</span>
                        </div>
                    );
                }

                if (this.state.listType == 'new') {
                    $list = <NewDynamicList topicId = {parseInt(this.dynamicId, 10)} ref="list"/>;
                }
            }

            return (
                <div className="app-home app-topic">
                    { $content }

                    <div className="hotlist-wrapper">
                        <div className="hotlist-header">
                            <h2 onClick={()=>this.selectList('hot')}>
                                <span className={this.state.listType == 'hot' ? "selected":""}>{ lang.template('热门') }</span>
                            </h2>  
                            <h2 onClick={()=>this.selectList('new')}>
                                <span className={this.state.listType == 'new' ? "selected":""}>{ lang.template('最新') }</span>
                            </h2>                   
                        </div>
                        
                        { $list }
                        
                    </div>
                    <div className="topic-bottom-guide" onClick={()=>dl()}>
                        <div className="desc">{lang.template('打开Up直播，直播全世界')}</div>
                        <button className="btn">{lang.template('立即打开')}</button>
                    </div>
                </div>
            );
        }
	}
}

export default TopicView;


// WEBPACK FOOTER //
// ./js/topic/index.js